import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * Supplies Worker entry: send `/` to supplies home
 * (auth layout redirects unauthenticated users to /login).
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/supplies" })
  },
})
